import React from 'react';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import { ValueInput } from '../../atoms/valueInput';
import { AmountSelector } from '../../atoms/AmountSelector';
import { DrawerSectionTitle } from '../../atoms/drawerSectionTitle';

export const DepositAmountSection = ({
  control,
  errors,
  depositAmount,
  handleSetDepositAmount,
  amountOptions,
  minimumAmount,
  maximumAmount,
  currencySymbol,
  currencyCode,
  isPage,
  translate,
}) => (
  <section>
    <DrawerSectionTitle title={translate('depositAmountTitle1')} />

    <Controller
      name="depositAmount"
      control={control}
      rules={{
        required: true,
        validate: (value) => {
          if (!value) return true;
          if (value < minimumAmount && value !== 0) {
            return `${translate('payments.minimumDepositAmount')} ${currencySymbol}${minimumAmount}`;
          }
          if (value > maximumAmount) {
            return `${translate('payments.maximumDepositAmount')} ${currencySymbol}${maximumAmount}`;
          }
        },
      }}
      render={({ field }) => (
        <ValueInput
          disabled={false}
          errors={errors?.depositAmount}
          placeholder={`${minimumAmount}-${maximumAmount}`}
          currencySymbol={currencySymbol}
          {...field}
        />
      )}
    />

    <AmountSelector
      maximumAmount={maximumAmount}
      minimumAmount={minimumAmount}
      amountOptions={amountOptions}
      depositAmount={depositAmount}
      setDepositAmount={handleSetDepositAmount}
      currencyCode={currencyCode}
      currencySymbol={currencySymbol}
      fullWidth={!!isPage}
    />
  </section>
);

DepositAmountSection.propTypes = {
  control: PropTypes.object.isRequired,
  errors: PropTypes.object,
  depositAmount: PropTypes.number,
  handleSetDepositAmount: PropTypes.func.isRequired,
  amountOptions: PropTypes.arrayOf(PropTypes.number),
  minimumAmount: PropTypes.number,
  maximumAmount: PropTypes.number,
  currencySymbol: PropTypes.string,
  currencyCode: PropTypes.string,
  isPage: PropTypes.bool,
  translate: PropTypes.func.isRequired,
};
